import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const cashFlowApi = createApi({
  reducerPath: "cashFlowApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),

  tagTypes: ["CashFlow", "Wallet", "DebtCredit"],

  endpoints: (builder) => ({

    // 📊 Cash Flow Report
    getCashFlowReport: builder.query({
      query: ({
        from,
        to,
        branchId,
        mode,
        refNo,
      } = {}) => {
        const params = {};

        if (from) params.from = from;
        if (to) params.to = to;
        if (branchId) params.branchId = branchId;
        if (mode) params.mode = mode;
        if (refNo) params.refNo = refNo;

        return {
          url: "/cash-flow",
          params,
        };
      },
      providesTags: ["CashFlow"],
    }),

    // 💳 Wallet Report
    getWalletReport: builder.query({
      query: ({
        from,
        to,
        branchId,
        customerId,
      } = {}) => {
        const params = {};

        if (from) params.from = from;
        if (to) params.to = to;
        if (branchId) params.branchId = branchId;
        if (customerId) params.customerId = customerId;

        return {
          url: "/cash-flow/wallet",
          params,
        };
      },
      providesTags: ["Wallet"],
    }),

    // 📒 Debt / Credit Report
    getDebtCreditReport: builder.query({
      query: ({
        branchId,
        customerId,
      } = {}) => {
        const params = {};

        if (branchId) params.branchId = branchId;
        if (customerId) params.customerId = customerId;

        return {
          url: "/cash-flow/debt-credit",
          params,
        };
      },
      providesTags: ["DebtCredit"],
    }),

  }),
});

export const {
  useGetCashFlowReportQuery,
  useGetWalletReportQuery,
  useGetDebtCreditReportQuery,   // 👈 NEW HOOK
} = cashFlowApi;

export default cashFlowApi;
